// extracted by mini-css-extract-plugin
export default {"footerSection":"Footer_footerSection__366il","first":"Footer_first__xUBNs","second":"Footer_second__IA56m","third":"Footer_third__7pXkw"};